export default __webpack_public_path__ + "static/media/rice04.32a95de9.png";